import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSingleDayEvent: true,
    eventHasSlots: false,
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    eventSchedule: []
};

const createEvent = createSlice({
    name: 'createEvent',
    initialState,
    reducers: {
        createEventSchedule: (state, action) => {
            const {
                isSingleDayEvent,
                eventHasSlots,
                startDate,
                endDate,
                startTime,
                endTime,
                eventSchedule
            } = action.payload;
            state.isSingleDayEvent = isSingleDayEvent;
            state.eventHasSlots = eventHasSlots;
            state.startDate = startDate;
            state.endDate = endDate;
            state.startTime = startTime;
            state.endTime = endTime;
            state.eventSchedule = eventSchedule;
            console.log('Event Schedule State :', JSON.parse(JSON.stringify(state)));
        }
    }
});

export const { createEventSchedule } = createEvent.actions;
// console.log(createEventSchedule())

export default createEvent.reducer;
